import {
  BUTTON,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Interactive9: Translator = sequence => {
  const Columns: LayoutColumnsDefinition[] = [];

  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      Columns.push({
        type: LAYOUT_COLUMNS,
        id: '1',
        values: {
          type: 'li',
          py: '30px',
          gridTemplateColumns: '1fr'
        },
        items: [
          {
            id: item.id,
            type: LAYOUT_LIST,
            values: { align: 'left', padding: '0px 0px 10px 0px' },
            items: [
              {
                id: `${item.id}_title`,
                type: TEXT,
                values: {
                  value: item.title,
                  variant: 'heading2'
                },
                items: []
              },
              {
                id: `${item.id}_body`,
                type: TEXT,
                values: {
                  value: item.body
                },
                items: []
              }
            ]
          } as LayoutListDefinition,
          {
            type: BUTTON,
            id: '1',
            values: {
              type: 'link',
              display: 'inline-flex',
              title:
                item.items && item.items.length > 0 && item.items[0].title
                  ? item.items[0].title
                  : 'More',
              url:
                item.items && item.items.length > 0 && item.items[0].url
                  ? item.items[0].url
                  : 'https://www.easyllama.com/'
            },
            items: []
          }
        ]
      });
    }

    return null;
  });

  root.items.push({
    id: 'test',
    type: LAYOUT_LIST,
    values: {
      align: 'center'
    },
    items: [
      CardHelper({} as ItemOfType<'Card'>, {
        width: '80vw',
        height: 'auto',
        padding: { _: '0px', md: '0px' },
        type: 'ol',
        extraItems: Columns
      })
    ]
  });

  return root;
};
